export const CheckboxSize = {
  Small: 'small',
  Medium: 'medium',
  Large: 'large',
} as const;

export type CheckboxSize = (typeof CheckboxSize)[keyof typeof CheckboxSize];
